function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1879",
    d: "M21.75-7.1h-1.223a4.593 4.593 0 0 0 .473-2 4.275 4.275 0 0 0-4.125-4.4c-1.95 0-3.211 1.065-4.828 3.415-1.617-2.35-2.878-3.415-4.828-3.415a4.275 4.275 0 0 0-4.125 4.4 4.528 4.528 0 0 0 .473 2H2.25A2.329 2.329 0 0 0 0-4.7v6.4a.779.779 0 0 0 .75.8h.75v5.37a2.555 2.555 0 0 0 2.466 2.63h16.068A2.555 2.555 0 0 0 22.5 7.87V2.5h.75a.779.779 0 0 0 .75-.8v-6.4a2.329 2.329 0 0 0-2.25-2.4zM10.875 8.1H3.966a.222.222 0 0 1-.216-.23V2.5H9V.1H2.25v-4.8h8.625zM7.214-7.1a1.94 1.94 0 0 1-1.875-2 1.94 1.94 0 0 1 1.875-2c1.031 0 1.758.38 3.942 3.85l.094.15zm5.719-.15c2.184-3.47 2.911-3.85 3.942-3.85a1.94 1.94 0 0 1 1.875 2 1.94 1.94 0 0 1-1.875 2h-4.036zM21.75.1H15v2.4h5.25v5.37a.223.223 0 0 1-.216.23h-6.909V-4.7h8.625z",
    transform: "translate(0 13.5)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftIcon);
export default __webpack_public_path__ + "static/media/gift-icon.7d8b935f.svg";
export { ForwardRef as ReactComponent };